import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable, NgModule } from '@angular/core';
import { JsonResourceResponse } from 'app/generated/generated-common';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { SetCargoGroupRequest } from 'app/generated/backend/shipment/api/set-cargo-group-request';
import { SetCargoGroupResponse } from 'app/generated/backend/shipment/api/set-cargo-group-response';

@Injectable()
export class SetCargoGroupHandlerService {
	private handleError(error: Response | any) {
		return throwError(error);
	}
	constructor(private http: HttpClient) { }
	post(
		request: SetCargoGroupRequest
	): Observable<JsonResourceResponse<SetCargoGroupResponse>> {
		return this.http.post<JsonResourceResponse<SetCargoGroupResponse>>('api/v1/shipment/setCargoGroup', request).pipe(
			map(response => response),
			catchError(this.handleError));
	}
}

@NgModule({
	imports: [
		CommonModule
	],
	providers: [
		SetCargoGroupHandlerService
	]
})
export class SetCargoGroupHandlerModule { }
